import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Configuración básica para Toasts (Notificaciones flotantes)
const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-right',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  background: '#ffffff',
  color: '#0f172a',
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
});

// Utilidad universal para notificaciones
const parseParams = (title, options) => {
  if (typeof options === 'object' && options !== null) {
    return { title, text: options.description || options.text || '' };
  }
  return { title, text: options || '' };
};

export const toast = {
  success: (title, options) => Toast.fire({ icon: 'success', ...parseParams(title, options) }),
  error: (title, options) => Toast.fire({ icon: 'error', ...parseParams(title, options) }),
  warning: (title, options) => Toast.fire({ icon: 'warning', ...parseParams(title, options) }),
  info: (title, options) => Toast.fire({ icon: 'info', ...parseParams(title, options) }),
  loading: (title) => Swal.fire({ 
    title, 
    allowOutsideClick: false, 
    didOpen: () => Swal.showLoading() 
  }),
  dismiss: () => Swal.close()
};

// Confirmación personalizada premium
export const confirm = async (title, text, icon = 'warning') => {
  return await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: '#ED5F0F', // Color naranja global
    cancelButtonColor: '#64748b',
    confirmButtonText: 'Sí, continuar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    customClass: {
      popup: 'rounded-2xl border-0 shadow-2xl',
      confirmButton: 'rounded-xl px-6 py-2 font-bold',
      cancelButton: 'rounded-xl px-6 py-2 font-bold'
    }
  });
};

export default Swal;
